import AtomicPressFormance from "../../../../src/courses/partials/atomic/pressformance.mdx";
import * as React from 'react';
export default {
  AtomicPressFormance,
  React
};